import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';

export const EditDTRRuleSkeleton = () => {
  return (
    <>
      <SectionSkeleton width={150} />
    </>
  );
};
